import React, { useState } from 'react';
import './BuyAsics.css';
import '../../components/Contact/Contact.css';
import '../../components/Faq/Faq.css';
import '../../components/Disclaimer/Disclaimer.css';
import '../../components/Button/Button.css';

const BuyAsics = () => {
  const [expandedFaq, setExpandedFaq] = useState({});
  const [selectedModel, setSelectedModel] = useState('Antminer S21 Pro 245TH/s');
  const [quantity, setQuantity] = useState(1);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleFaq = (index) => {
    setExpandedFaq(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const scrollToMining = () => {
    const element = document.getElementById('mining');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const asicCards = [
    {
      label: 'Most powerful',
      labelType: 'blue',
      title: 'Antminer S21 XP',
      power: '270 TH/s',
      monthlyOutput: '$482',
      price: '$4 650',
      link: '/order/buy-asics/87/1',
      image: 'https://files.ecos.am/asics/png/S21XpGrey.png'
    },
    {
      label: 'New',
      labelType: 'most-powerful',
      title: 'Antminer S21 Pro',
      power: '245 TH/s',
      monthlyOutput: '$425',
      price: '$3 430',
      link: '/order/buy-asics/91/1',
      image: 'https://files.ecos.am/asics/png/S21ProGrey.png'
    },
    {
      title: 'Antminer S21+',
      power: '235 TH/s',
      monthlyOutput: '$387',
      price: '$3 200',
      link: '/order/buy-asics/94/1',
      image: 'https://files.ecos.am/images/zGulRgMjlfz5wKMY5FIaIq5dQr8TnobaVRgFSACY.png'
    },
    {
      label: 'Bestseller',
      labelType: 'most-powerful',
      title: 'Antminer S21 Pro',
      power: '234 TH/s',
      monthlyOutput: '$400',
      price: '$3 300',
      link: '/order/buy-asics/90/1',
      image: 'https://files.ecos.am/asics/png/S21ProGrey.png'
    },
    {
      title: 'Antminer S21+',
      power: '225 TH/s',
      monthlyOutput: '$368',
      price: '$2 950',
      link: '/order/buy-asics/93/1',
      image: 'https://files.ecos.am/images/wq5or9tbhLJb1aLG1cvh82nIJjmreuEAom1k8r00.png'
    },
    {
      title: 'Antminer S21',
      power: '200 TH/s',
      monthlyOutput: '$302',
      price: '$2 650',
      link: '/order/buy-asics/84/1',
      image: 'https://files.ecos.am/asics/png/S21Grey.png'
    },
    {
      title: 'Antminer S21',
      power: '188 TH/s',
      monthlyOutput: '$277',
      price: '$2 550',
      link: '/order/buy-asics/83/1',
      image: 'https://files.ecos.am/asics/png/S21Grey.png'
    },
    {
      title: 'Antminer S19j XP',
      power: '151 TH/s',
      monthlyOutput: '$197',
      price: '$1 500',
      link: '/order/buy-asics/92/1',
      image: 'https://files.ecos.am/images/mbn8RbhykuaEBbrfb7Qhme0Q2mXQ9EX1zyTtINS6.png'
    },
    {
      title: 'Antminer S19K Pro',
      power: '120 TH/s',
      monthlyOutput: '$139',
      price: '$950',
      link: '/order/buy-asics/81/1',
      image: 'https://files.ecos.am/images/QahvyXHPrUtllh9H4FI5oVINjDUkTzb8PgNkl5tn.png'
    }
  ];

  const asicModels = [
    'Antminer S21 XP 270TH/s',
    'Antminer S21 Pro 245TH/s',
    'Antminer S21+ 235TH/s',
    'Antminer S21 Pro 234TH/s',
    'Antminer S21+ 225TH/s',
    'Antminer S21 200TH/s',
    'Antminer S21 188TH/s',
    'Antminer S19j XP 151TH/s',
    'Antminer S19K Pro 120TH/s'
  ];

  const getSelectedAsic = () => {
    // Match based on the power value in selectedModel
    // e.g., "Antminer S21 Pro 245TH/s" -> extract "245TH/s" and find matching card
    const powerMatch = selectedModel.match(/(\d+)TH\/s/);
    if (powerMatch) {
      const powerValue = powerMatch[1] + ' TH/s';
      return asicCards.find(card => card.power === powerValue) || asicCards[1];
    }
    // Fallback: try to match by title (without the TH/s part)
    const modelName = selectedModel.split(' ').slice(0, -1).join(' ');
    return asicCards.find(card => {
      // Handle cases where title might be "Antminer S21 Pro" but selectedModel is "Antminer S21 Pro 245TH/s"
      return card.title === modelName || selectedModel.includes(card.title);
    }) || asicCards[1];
  };

  const selectedAsic = getSelectedAsic();
  const totalPrice = quantity * parseInt(selectedAsic.price.replace(/[^0-9]/g, '').replace(/\s/g, ''));

  const faqQuestions = [
    'What is a cryptocurrency mining farm?',
    'What is an ASIC?',
    'What are the advantages of buying a hosted ASIC with FX-Pool?',
    'What is the best ASIC to buy?',
    'What is the hosting fee for?',
    'How much can I earn by purchasing an ASIC?',
    'How can I start mining BTC with FX-Pool?'
  ];

  const steps = [
    {
      number: '1 step',
      title: 'Select & Order an ASIC',
      subtitle: 'Explore our marketplace and purchase top miners securely.'
    },
    {
      number: '2 step',
      title: 'Hassle-free setup',
      subtitle: 'We handle logistics, setup, hosting, and maintenance.'
    },
    {
      number: '3 step',
      title: 'Start Mining',
      subtitle: 'Your miner works 24/7. Earned BTC is sent directly to your wallet daily.'
    },
    {
      number: '4 step',
      title: 'Monitor with Ease',
      subtitle: 'Manage and track your miner easily via our mobile app.'
    }
  ];

  return (
    <div className="mining-farm-container holder">
      {/* Header Section */}
      <div className="mining-farm">
        <div className="mining-farm__header">
          <div className="mining-farm__title-block">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <g clipPath="url(#clip0_6330_23156)">
                <path d="M0.54 7.7C0.54 6.43097 0.54042 5.51168 0.599515 4.78838C0.658096 4.07139 0.771631 3.59469 0.971614 3.2022C1.35127 2.45708 1.95708 1.85127 2.7022 1.47161C3.09469 1.27163 3.57139 1.1581 4.28838 1.09952C5.01168 1.04042 5.93097 1.04 7.2 1.04H16.8C18.069 1.04 18.9883 1.04042 19.7116 1.09952C20.4286 1.1581 20.9053 1.27163 21.2978 1.47161C22.0429 1.85127 22.6487 2.45708 23.0284 3.2022C23.2284 3.59469 23.3419 4.07139 23.4005 4.78838C23.4596 5.51168 23.46 6.43097 23.46 7.7V17.3C23.46 18.569 23.4596 19.4883 23.4005 20.2116C23.3419 20.9286 23.2284 21.4053 23.0284 21.7978C22.6487 22.5429 22.0429 23.1487 21.2978 23.5284C20.9053 23.7284 20.4286 23.8419 19.7116 23.9005C18.9883 23.9596 18.069 23.96 16.8 23.96H7.2C5.93097 23.96 5.01168 23.9596 4.28838 23.9005C3.57139 23.8419 3.09469 23.7284 2.7022 23.5284C1.95708 23.1487 1.35127 22.5429 0.971614 21.7978C0.771631 21.4053 0.658096 20.9286 0.599515 20.2116C0.54042 19.4883 0.54 18.569 0.54 17.3V7.7Z" stroke="#1570EF" strokeWidth="1.08" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M0.525 7.7C0.525 6.43122 0.525408 5.51121 0.584565 4.78716C0.643221 4.06924 0.757009 3.59034 0.958249 3.19539C1.33935 2.44744 1.94744 1.83935 2.69539 1.45825C3.09034 1.25701 3.56924 1.14322 4.28716 1.08457C5.01121 1.02541 5.93122 1.025 7.2 1.025H16.8C18.0688 1.025 18.9888 1.02541 19.7128 1.08457C20.4308 1.14322 20.9097 1.25701 21.3046 1.45825C22.0526 1.83935 22.6607 2.44744 23.0417 3.19539C23.243 3.59034 23.3568 4.06924 23.4154 4.78716C23.4746 5.51121 23.475 6.43122 23.475 7.7V17.3C23.475 18.5688 23.4746 19.4888 23.4154 20.2128C23.3568 20.9308 23.243 21.4097 23.0417 21.8046C22.6607 22.5526 22.0526 23.1607 21.3046 23.5417C20.9097 23.743 20.4308 23.8568 19.7128 23.9154C18.9888 23.9746 18.0688 23.975 16.8 23.975H7.2C5.93122 23.975 5.01121 23.9746 4.28716 23.9154C3.56924 23.8568 3.09034 23.743 2.69539 23.5417C1.94744 23.1607 1.33935 22.5526 0.958249 21.8046C0.757009 21.4097 0.643221 20.9308 0.584565 20.2128C0.525408 19.4888 0.525 18.5688 0.525 17.3V7.7Z" stroke="#1570EF" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M8.39075 7.63168L8.69861 7.94634L9.06212 7.69806L9.65508 7.29307C9.65515 7.29301 9.65523 7.29296 9.6553 7.29291C11.2294 6.22014 13.1691 5.5148 15.5185 5.1753C15.7982 5.13652 15.9865 5.14577 16.122 5.17976C16.2476 5.21126 16.351 5.26955 16.4555 5.37443C16.6667 5.58626 16.7258 5.84924 16.6446 6.10511C16.6122 6.19937 16.589 6.24689 16.5669 6.28075C16.5468 6.31157 16.5154 6.34966 16.4461 6.40434C16.285 6.53145 15.9979 6.69103 15.3905 6.9989C13.5346 7.93939 12.6393 8.51641 11.6914 9.40016C11.6911 9.40042 11.6908 9.40068 11.6906 9.40095L11.2881 9.77309L10.887 10.1441L11.2737 10.5301L15.0355 14.2848C16.5767 15.8277 17.5162 16.7765 18.0812 17.3676C18.3645 17.664 18.5468 17.8634 18.6618 17.9993C18.7514 18.1052 18.7806 18.1507 18.7856 18.1572C18.973 18.6957 18.4118 19.2646 17.844 19.0552C17.8386 19.0509 17.832 19.0457 17.8243 19.0394C17.7806 19.0039 17.7169 18.9488 17.6302 18.8704C17.4577 18.7144 17.2121 18.4827 16.8874 18.1692C16.2389 17.5431 15.2883 16.6037 14.004 15.3217C12.9742 14.2918 12.0307 13.358 11.3401 12.6827C10.9951 12.3453 10.7119 12.0711 10.5121 11.8814C10.4128 11.787 10.3314 11.711 10.2724 11.6577C10.2438 11.632 10.2151 11.6067 10.1901 11.5863C10.1792 11.5774 10.1588 11.561 10.1346 11.5447C10.1245 11.5379 10.0972 11.5196 10.0603 11.5022C10.0428 11.4939 10.0049 11.4769 9.9541 11.465C9.91815 11.4565 9.7884 11.4281 9.63735 11.4888L9.63735 11.4888C9.54472 11.526 9.48022 11.5825 9.46796 11.5932C9.46732 11.5938 9.46683 11.5942 9.46648 11.5945C9.43916 11.618 9.4139 11.6428 9.39345 11.6638C9.35151 11.7067 9.30368 11.7602 9.2543 11.8176C9.15422 11.9338 9.02826 12.0886 8.89341 12.2598C8.62354 12.6022 8.30455 13.0271 8.06365 13.3732L8.06248 13.3749C7.47906 14.2203 7.01913 15.0072 6.51781 15.9937L6.51684 15.9956C6.16316 16.6986 6.10358 16.7434 6.01284 16.8059L6.01282 16.8058L6.00731 16.8097C5.62693 17.0786 5.09691 16.9314 4.90713 16.4783L4.90698 16.4779C4.88608 16.4282 4.85307 16.251 4.89478 15.8342C4.93413 15.4409 5.03102 14.907 5.19331 14.2026L5.19349 14.2018C5.53344 12.7159 6.22197 11.1113 7.00397 9.95254C7.0041 9.95235 7.00423 9.95216 7.00436 9.95196L7.40761 9.35782L7.6533 8.99583L7.34155 8.68889L7.0013 8.35389C7.0012 8.35379 7.0011 8.35369 7.001 8.35359C6.63824 7.99511 6.56394 7.77322 6.56394 7.57483C6.56394 7.33536 6.62128 7.20152 6.78443 7.04468C6.8849 6.95148 6.9509 6.91241 7.00508 6.89111C7.05999 6.86953 7.13819 6.8523 7.28253 6.8523C7.47846 6.8523 7.69893 6.92591 8.05653 7.29008C8.05662 7.29017 8.05672 7.29027 8.05681 7.29036L8.39075 7.63168ZM17.863 19.0695C17.8627 19.0693 17.8624 19.0691 17.8621 19.0688C17.8651 19.0707 17.8666 19.0718 17.8663 19.0717C17.8662 19.0716 17.8651 19.0709 17.863 19.0695Z" stroke="#1570EF" strokeWidth="1.05"></path>
              </g>
              <defs>
                <clipPath id="clip0_6330_23156">
                  <rect width="24" height="24" fill="white" transform="translate(0 0.5)"></rect>
                </clipPath>
              </defs>
            </svg>
            <p className="mining-farm__title">Buy Asics</p>
          </div>
          <div className="mining-farm__header-block">
            <picture className="cover-picture">
              <img src="/images/buy-asics/banner_2.png" alt="banner" loading="lazy" />
            </picture>
            <a href="#mining" className="mining-farm__header-arrow" onClick={(e) => { e.preventDefault(); scrollToMining(); }}>
              <svg id="circle-arrow" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <rect data-figma-bg-blur-radius="8" width="32" height="32" rx="16" fill="black" fillOpacity="0.4"></rect>
                <path d="M22 14L16 20L10 14" stroke="white" strokeWidth="2" strokeLinecap="round"></path>
              </svg>
            </a>
            <div className="mining-farm__banner-content">
              <p className="mining-farm__header-title">Purchase ASIC for steady BTC rewards!</p>
              <p className="mining-farm__header-subtitle">With FX-Pool, you benefit from low energy costs, full equipment management, and consistent returns without technical headaches.</p>
            </div>
          </div>
        </div>
      </div>

      {/* ASIC Cards Section */}
      <div className="offer" id="mining">
        <div className="offer__cards-block">
          <div className="offer__card-block holder">
            {asicCards.map((card, index) => (
              <div key={index} className="offer__cards">
                <div className="offer__card">
                  {card.label && (
                    <span className={card.labelType === 'blue' ? 'offer__label-blue offer__label-most-powerful' : `offer__label-${card.labelType || 'most-powerful'}`}>
                      {card.label}
                    </span>
                  )}
                  <p className="offer__card-title">{card.title}</p>
                  <p className="offer__card-power">{card.power}</p>
                  <div className="offer__card-subtitle-block">
                    <div className="offer__card-output-block">
                      <p className="offer__card-title-output">Monthly Output:</p>
                      <p className="offer__card-value">{card.monthlyOutput}</p>
                      <div className="tooltip">
                        <div className="tooltip-text" style={{ display: 'none' }}>The amount of BTC earned (in $) after deducting hosting fee</div>
                        <svg className="default" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <g clipPath="url(#clip0_264_44934)">
                            <path d="M9.00018 12.2727V8.99999M9.00018 5.72727H9.00836M17.182 8.99999C17.182 13.5187 13.5189 17.1818 9.00018 17.1818C4.48148 17.1818 0.818359 13.5187 0.818359 8.99999C0.818359 4.4813 4.48148 0.818176 9.00018 0.818176C13.5189 0.818176 17.182 4.4813 17.182 8.99999Z" stroke="#667085" strokeLinecap="round" strokeLinejoin="round"></path>
                          </g>
                          <defs>
                            <clipPath id="clip0_264_44934">
                              <rect width="18" height="18" fill="white"></rect>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div>
                    <div className="offer__card-wrapper-image">
                      <img className="offer__card-image" src={card.image} alt="Contract image" />
                    </div>
                  </div>
                  <div className="offer__buy-button-background">
                    <a href={card.link} className="offer__buy-button">
                      <button className="primary" type="button">
                        {card.price}
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Disclaimer Section */}
      <div className="info">
        <div className="info__disclaimer-block">
          <div className="disclaimer">
            <p className="disclaimer__title">Disclaimer</p>
            <p className="disclaimer__description">
              These estimates offer forward-looking information based on current data, including mining difficulty: FPPS 0.00000041, and BTC reference rate of $175k. They are not guarantees of future results and should be viewed with caution due to market uncertainties.
            </p>
          </div>
        </div>
      </div>

      {/* Steps Section */}
      <div className="steps-container">
        <h2 className="steps__title">From Order to Earnings</h2>
        <div className="steps">
          {steps.map((step, index) => (
            <div key={index} className="step">
              <div className="step__block">
                <div className="step__number">{step.number}</div>
                {index < steps.length - 1 && (
                  <svg xmlns="http://www.w3.org/2000/svg" width="51" height="16" viewBox="0 0 51 16" fill="none">
                    <path d="M49.9571 8.70711C50.3476 8.31658 50.3476 7.68342 49.9571 7.29289L43.5931 0.928932C43.2026 0.538408 42.5695 0.538408 42.1789 0.928932C41.7884 1.31946 41.7884 1.95262 42.1789 2.34315L47.8358 8L42.1789 13.6569C41.7884 14.0474 41.7884 14.6805 42.1789 15.0711C42.5695 15.4616 43.2026 15.4616 43.5931 15.0711L49.9571 8.70711ZM0.25 9H49.25V7H0.25V9Z" fill="#1570EF"></path>
                  </svg>
                )}
              </div>
              <div>
                <h3 className="step__title">{step.title}</h3>
                <p className="step__subtitle">{step.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Mining Farm Section */}
      <div className="mining-farm">
        <div className="mining-farm__img-block">
          <p className="mining-farm__asic-info-title mining-farm__asic-info-title_mobile">
            Purchase ASIC with a single click, and we'll host it at FX-Pool Data Center.
          </p>
          <div className="mining-farm__image-wrapper">
            <img className="mining-farm__image" src={selectedAsic.image} alt="asic" />
          </div>
        </div>
        <div className="mining-farm__asic-model-block">
          <div className="mining-farm__asic-model">
            <div className="mining-farm__asic-info">
              <div className="mining-farm__asic-info-title-block">
                <p className="mining-farm__asic-info-title mining-farm__asic-info-title_desktop">
                  Purchase ASIC with a single click, and we'll host it at FX-Pool Data Center.
                </p>
              </div>
              <div className="mining-farm__dropdown-block">
                <p className="mining-farm__dropdown-title">ASIC model</p>
                <div className="input__dropdown" style={{ position: 'relative' }}>
                  <div className="input__dropdown-content" onClick={() => setDropdownOpen(!dropdownOpen)}>
                    {selectedModel}
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className="input__dropdown-arrow" style={{ transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }}>
                      <path d="M5 7.5L10 12.5L15 7.5" stroke="#475467" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                  </div>
                  {dropdownOpen && (
                    <div className="mining-farm__dropdown-open" style={{ position: 'absolute', top: '40px', left: 0, width: '100%', zIndex: 9999 }}>
                      {asicModels.map((model, idx) => (
                        <div key={idx} className="mining-farm__dropdown-content" onClick={() => { setSelectedModel(model); setDropdownOpen(false); }}>
                          {model}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="mining-farm__quantity-group">
                <div className="mining-farm__quantity">
                  <p className="mining-farm__quantity-title">Quantity:</p>
                  <div className="mining-farm__quantity-block">
                    <div className="mining-farm__quantity-button-block">
                      <button className="transparent mining-farm__quantity-button" type="button" onClick={() => setQuantity(Math.max(1, quantity - 1))}>
                        -
                      </button>
                      <p className="mining-farm__quantity-value">{quantity}</p>
                      <button className="transparent mining-farm__quantity-button" type="button" onClick={() => setQuantity(quantity + 1)}>
                        +
                      </button>
                    </div>
                    <div className="mining-farm__discount-block">
                      <p className="mining-farm__discount-title">Discount:</p>
                      <p className="mining-farm__discount-title">0%</p>
                    </div>
                    <p className="mining-farm__calculate-discount-value">-$0</p>
                  </div>
                </div>
                <div className="mining-farm__duration mining-farm__duration_mobile-xs">
                  <p className="mining-farm__duration-title">Setup</p>
                  <div className="mining-farm__duration-value-block">
                    <div className="mining-farm__duration-extra-block">
                      <p className="mining-farm__duration-active mining-farm__duration-value">14 days</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mining-farm__info">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none" className="mining-farm__speaker">
                  <path d="M4.39436 12.818L5.82585 18.544C5.86611 18.705 5.88624 18.7855 5.91005 18.8559C6.14269 19.5427 6.76119 20.0256 7.48392 20.0847C7.5579 20.0907 7.6409 20.0907 7.80689 20.0907C8.01475 20.0907 8.11869 20.0907 8.20624 20.0822C9.07162 19.9983 9.75648 19.3135 9.84041 18.4481C9.8489 18.3605 9.8489 18.2566 9.8489 18.0487V5.09074M17.5762 12.3635C19.3334 12.3635 20.758 10.9389 20.758 9.18165C20.758 7.42438 19.3334 5.99983 17.5762 5.99983M10.0762 5.09074H6.66708C4.40773 5.09074 2.57617 6.9223 2.57617 9.18165C2.57617 11.441 4.40774 13.2726 6.66708 13.2726H10.0762C11.682 13.2726 13.6464 14.1334 15.1619 14.9595C16.046 15.4415 16.4881 15.6824 16.7776 15.647C17.0461 15.6141 17.2491 15.4936 17.4065 15.2736C17.5762 15.0363 17.5762 14.5617 17.5762 13.6123V4.751C17.5762 3.80164 17.5762 3.32697 17.4065 3.08973C17.2491 2.86974 17.0461 2.74919 16.7776 2.71631C16.4881 2.68085 16.046 2.92183 15.1619 3.40379C13.6464 4.22993 11.682 5.09074 10.0762 5.09074Z" stroke="#1570EF" strokeWidth="1.21212" strokeLinecap="round" strokeLinejoin="round"></path>
                </svg>
                <p className="mining-farm__speaker-title">Buy 5 or more miners and enjoy a special discount!</p>
              </div>
            </div>
            <div className="mining-rarm__calculate">
              <div className="mining-farm__duration mining-farm__duration_desktop">
                <p className="mining-farm__duration-title">Setup</p>
                <div className="mining-farm__duration-value-block">
                  <div className="mining-farm__duration-extra-block">
                    <p className="mining-farm__duration-active mining-farm__duration-value">14 days</p>
                  </div>
                </div>
              </div>
              <div className="mining-farm__calculate-block">
                <div className="mining-farm__duration mining-farm__duration_mobile">
                  <p className="mining-farm__duration-title">Setup Duration</p>
                  <div className="mining-farm__duration-value-block">
                    <div className="mining-farm__duration-extra-block">
                      <p className="mining-farm__duration-active mining-farm__duration-value">14 days</p>
                    </div>
                  </div>
                </div>
                <div className="mining-farm__calculate-group">
                  <div className="mining-farm__price-catalog-block">
                    <p className="mining-farm__title-catalog">ASIC Price:</p>
                    <p className="mining-farm__price-catalog">{selectedAsic.price}</p>
                  </div>
                  <div className="mining-farm__price-block">
                    <p className="mining-farm__price-title">Total Price:</p>
                    <p className="mining-farm__price-value">${totalPrice.toLocaleString()}</p>
                  </div>
                </div>
                <a href={selectedAsic.link} className="mining-farm__next-button">
                  <button className="orange" type="button">
                    Next
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Questions Container */}
      <div className="background-mobile">
        <div className="questions-container">
          <p className="questions-title">We are here 24/7 to answer any questions</p>
          <p className="questions-subtitle">Can't find the answer you're looking for? Please chat to our friendly team.</p>
          <a href="https://t.me/FXPool_BTC_Mining_bot" target="_blank" rel="noopener noreferrer">
            <button className="orange" type="button">
              Chat with us
            </button>
          </a>
        </div>
      </div>

      {/* Journey Section */}
      <div className="background-mobile">
        <div className="journey">
          <div className="journey__title-block">
            <h2 className="journey__title">Simplify Your Bitcoin Mining Journey</h2>
            <p className="journey__subtitle">With FX-Pool, it's easy to purchase, host, and earn.</p>
          </div>
          <div className="journey__faq-section">
            <div className="journey__faq-item">
              <svg className="journey__icon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                <g clipPath="url(#clip0_10196_39589)">
                  <path d="M8.25065 3.20801V1.83301M4.63959 4.63861L3.66732 3.66634M4.63959 11.9163L3.66732 12.8886M11.9173 4.63861L12.8896 3.66634M3.20898 8.24967H1.83398M7.79232 7.79134L11.5608 19.5043L14.209 16.8562L17.5192 20.1663L20.1673 17.5182L16.8571 14.208L19.5053 11.5599L7.79232 7.79134Z" stroke="#84CAFF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"></path>
                </g>
                <defs>
                  <clipPath id="clip0_10196_39589">
                    <rect width="22" height="22" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
              <div>
                <p className="journey__faq-subtitle">Buy Top-Performing ASICs Purchase most efficient ASIC with one click!</p>
                <a href="https://cp.ecos.am/order/buy-asics/65/1" target="_blank" rel="noopener noreferrer">
                  <button className="journey__btn">Learn More</button>
                </a>
              </div>
            </div>
            <div className="journey__faq-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
                <path d="M35.8984 10H30.5651C27.7648 10 26.3647 10 25.2952 10.545C24.3543 11.0243 23.5894 11.7892 23.1101 12.73C22.5651 13.7996 22.5651 15.1997 22.5651 18V20M35.8984 10L30.8984 5M35.8984 10L30.8984 15M17.5651 5H13.8984C11.0982 5 9.69804 5 8.62848 5.54497C7.68767 6.02433 6.92277 6.78924 6.4434 7.73005C5.89844 8.79961 5.89844 10.1997 5.89844 13V27C5.89844 29.8003 5.89844 31.2004 6.4434 32.27C6.92277 33.2108 7.68767 33.9757 8.62848 34.455C9.69804 35 11.0982 35 13.8984 35H27.8984C30.6987 35 32.0988 35 33.1684 34.455C34.1092 33.9757 34.8741 33.2108 35.3535 32.27C35.8984 31.2004 35.8984 29.8003 35.8984 27V23.3333" stroke="#84CAFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
              </svg>
              <div>
                <p className="journey__faq-subtitle">Start with affordable investment. Explore our ASICs Marketplace.</p>
                <a href="https://cp.ecos.am/marketplace" target="_blank" rel="noopener noreferrer">
                  <button className="journey__btn">Learn More</button>
                </a>
              </div>
            </div>
            <div className="journey__faq-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none">
                <path d="M6.5 21.1306C6.5 19.9819 6.5 19.4075 6.64805 18.8786C6.7792 18.4101 6.99473 17.9694 7.28405 17.5782C7.61067 17.1366 8.06404 16.784 8.97078 16.0787L22.5354 5.52849C23.238 4.98198 23.5894 4.70873 23.9773 4.60369C24.3196 4.51101 24.6804 4.51101 25.0227 4.60369C25.4106 4.70873 25.762 4.98198 26.4646 5.52849L40.0292 16.0787C40.936 16.784 41.3893 17.1366 41.7159 17.5782C42.0053 17.9694 42.2208 18.4101 42.3519 18.8786C42.5 19.4075 42.5 19.9819 42.5 21.1306V35.6005C42.5 37.8407 42.5 38.9608 42.064 39.8164C41.6805 40.5691 41.0686 41.181 40.316 41.5645C39.4603 42.0005 38.3402 42.0005 36.1 42.0005H12.9C10.6598 42.0005 9.53968 42.0005 8.68404 41.5645C7.93139 41.181 7.31947 40.5691 6.93597 39.8164C6.5 38.9608 6.5 37.8407 6.5 35.6005V21.1306Z" stroke="#84CAFF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M21.5 16V18M27.5 16V18M21.5 34V36M27.5 34V36M32.5 23H34.5M32.5 28H34.5M14.5 23H16.5M14.5 28H16.5M21.3 34H27.7C29.3802 34 30.2202 34 30.862 33.673C31.4265 33.3854 31.8854 32.9265 32.173 32.362C32.5 31.7202 32.5 30.8802 32.5 29.2V22.8C32.5 21.1198 32.5 20.2798 32.173 19.638C31.8854 19.0735 31.4265 18.6146 30.862 18.327C30.2202 18 29.3802 18 27.7 18H21.3C19.6198 18 18.7798 18 18.138 18.327C17.5735 18.6146 17.1146 19.0735 16.827 19.638C16.5 20.2798 16.5 21.1198 16.5 22.8V29.2C16.5 30.8802 16.5 31.7202 16.827 32.362C17.1146 32.9265 17.5735 33.3854 18.138 33.673C18.7798 34 19.6198 34 21.3 34ZM23.1 29H25.9C26.4601 29 26.7401 29 26.954 28.891C27.1422 28.7951 27.2951 28.6422 27.391 28.454C27.5 28.2401 27.5 27.9601 27.5 27.4V24.6C27.5 24.0399 27.5 23.7599 27.391 23.546C27.2951 23.3578 27.1422 23.2049 26.954 23.109C26.7401 23 26.4601 23 25.9 23H23.1C22.5399 23 22.2599 23 22.046 23.109C21.8578 23.2049 21.7049 23.3578 21.609 23.546C21.5 23.7599 21.5 24.0399 21.5 24.6V27.4C21.5 27.9601 21.5 28.2401 21.609 28.454C21.7049 28.6422 21.8578 28.7951 22.046 28.891C22.2599 29 22.5399 29 23.1 29Z" stroke="#84CAFF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"></path>
              </svg>
              <div>
                <p className="journey__faq-subtitle">Explore our secure hosting facility at FX-Pool!</p>
                <a href="https://www.youtube.com/watch?v=1k_y8KyI0Y8" target="_blank" rel="noopener noreferrer">
                  <button className="journey__btn">Learn More</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="faq">
        <div className="faq__title-group">
          <div className="faq__question-block">
            <h2 className="faq__question-more">Frequently Asked Questions</h2>
            <p className="faq__about-rent">Uncover the details of buying an ASIC from FX-Pool</p>
          </div>
        </div>
        <div className="faq__question-group">
          {faqQuestions.map((question, index) => (
            <div key={index} className="faq__question-group-item">
              <div 
                className={`faq__question-title ${expandedFaq[index] ? 'faq__question-title--active' : ''}`} 
                onClick={() => toggleFaq(index)} 
                style={{ cursor: 'pointer' }}
              >
                {question}{' '}
                <span className="faq__item-border">
                  <svg 
                    className="faq__item-sign" 
                    width="12" 
                    height="12" 
                    viewBox="0 0 12 12" 
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line x1="6" y1="0" x2="6" y2="12"></line>
                    <line x1="0" y1="6" x2="12" y2="6"></line>
                  </svg>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BuyAsics;

